import React from 'react';
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../../library/form/components/FormLabel'
import FormWrapper from '../../../../../library/form/components/FormWrapper'
import FormTitle from '../../../../../library/form/components/FormTitle'
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColTwo, UiCol, UiRow } from "../../../../../library/layout/Index";
import DocAdminInfo from '../../../../cmn/DocAdminInfo';

const ProcessHeader = (props) => {
    const { formObject, masterKeys } = props;
    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span><FormTitle formObject={formObject} masterKeys={masterKeys} value='Process Header' /></span>
                </UiTitle>
                <UiAction>
                    <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                    <FormButton formObject={formObject} ksc="h" rowKey=""
                        starIcon={"edit"}
                            action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                             className="uiActionButton" text={<SarasTrans value="Edit" />}></FormButton>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
            <UiGridColTwo>
                <UiCol>
                <ul>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="Process ID" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className='uiVal' />
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refNo" }} value="Ref No" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "refNo" }} className='uiSpacerH10' />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "type" }} value="Process Type" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "type" }} className='uiVal' />
                    </li>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "subtype" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "subtype" }} value="Process Sub Type" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "subtype" }} className='uiVal' />
                    </FormWrapper>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "processName" }} value="Process Name" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "processName" }} className='uiVal' />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "processCode" }} value="Process Code" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "processCode" }} className='uiVal' />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nickName" }} value="Nick Name" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "nickName" }} className='uiVal' id="nickNameLbl" />
                    </li>
                </ul>
                </UiCol>
                <UiCol>
                    <ul>
                    <li style={{display:"none"}}>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qcTemplate" }} value="QC Template" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qcTemplate" }} className='uiSpacerH10' />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "unit1" }} value="Resource Time Unit" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "unit1" }} className='uiSpacerH10' />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "unit2" }} value="Resource Count Unit" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "unit2" }} className='uiSpacerH10' />
                    </li>
                    <li className='uiMultiValue'>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "requireResource" }} value="Require Mat." />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "requireResource" }} className='uiSpacerH10' />
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isInHouse" }} value="Is Inhouse" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isInHouse" }} className='uiSpacerH10' />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isActive" }} value="Active" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isActive" }} className='uiSpacerH10' />
                    </li>
                    </ul>
                </UiCol>
                </UiGridColTwo>
                <UiRow>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "desc" }} value="Remark" />
                    </span>
                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "desc" }} className='uiSpacerH10' />
                </UiRow>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ProcessHeader, "processHeader", "")